import { observable } from "mobx";
import { createContext } from "react";
import { offsetHtmlScrollbar } from "../utils/getScrollbarWidth";

export class PromptsState {

  private lastFocusedElement: Element | null = null;

  @observable
  public prompts = {
    userStatus: false,
    userRole: false,
    userTwoFactor: false,
    userPassword: false,
  };

  public closeAll = () => {
    if (document.body.parentElement!.style.overflowY === "auto") {
      return;
    }

    this.prompts = {
      userStatus: false,
      userRole: false,
      userTwoFactor: false,
      userPassword: false,
    };
    offsetHtmlScrollbar(false);
  };

  public togglePrompt = (promptName: string, open: boolean) => {
    if (open) {
      this.lastFocusedElement = document.activeElement;
      // const scroll = window.scrollY;
      offsetHtmlScrollbar(true);
      // window.scroll(window.scrollX, scroll);
    } else {
      if (this.lastFocusedElement instanceof HTMLElement) {
        this.lastFocusedElement.focus();
        this.lastFocusedElement = null;
      }
    }
    this.prompts[promptName] = open;

    let gotOpenPrompts = false;
    Object.entries(this.prompts).forEach((isOpen) => {
      if (isOpen[1]) {
        gotOpenPrompts = true;
      }
    });
    if (!gotOpenPrompts) {
      offsetHtmlScrollbar(false);
    }
  };
}

export const promptsContext = createContext(new PromptsState());
